import React, { useMemo } from "react"

import { FilterChip } from "@/components/common/Filters"
import { formattedCompanyDepartments } from "@/constants/companyDepartment"
import type { CompanyDepartment } from "@/graphql/codegen/graphql"

interface DepartmentChipsProps {
  companyDepartments: CompanyDepartment[] | undefined
  onRemove: (key: keyof any, value: CompanyDepartment) => void
}

export const DepartmentChips: React.FC<DepartmentChipsProps> = ({ companyDepartments, onRemove }) => {
  return useMemo(() => {
    if (!companyDepartments) return null
    return formattedCompanyDepartments
      .filter(({ original }) => companyDepartments.includes(original))
      .map(({ original, formatted }) => (
        <FilterChip
          key={`companyDepartments-${original}`}
          label={`Department: ${formatted}`}
          onDelete={() => onRemove("companyDepartments", original)}
        />
      ))
  }, [companyDepartments, onRemove])
}
